export const CONVERSATIONS_PER_PAGE = 25;

export const getBaseConversationPaginationMeta = ({
  currentPage,
  totalCount,
  hasAppliedFiltersOrActiveFolders,
  pageSize = CONVERSATIONS_PER_PAGE,
}) => {
  const hasLoadedAllConversations =
    !hasAppliedFiltersOrActiveFolders &&
    currentPage > 0 &&
    currentPage * pageSize >= totalCount;

  return {
    nextPage: currentPage + 1,
    hasLoadedAllConversations,
  };
};
